export default {
  label: {
    no: '订单号',
    systemOrderNo: '系统订单号',
    balance: '余额',
    amount: '转账金额',
    confirmTime: '确认时间',
    createTime: '创建时间',
    from: '转入',
    id: '主键id',
    message: '转账消息',
    status: '状态',
    to: '转出',
    type: '类型'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/userTransaction.js